import "./queryNotifications.css";

interface props {
	removeNotificationToken: () => void;
	setShowQueryNotification: (e: boolean) => void;
}
export const QueryNotifications = (props: props) => {
	const handleAnuluj = () => {
		props.setShowQueryNotification(false);
	};
	const handleRemove = () => {
		props.removeNotificationToken();
		props.setShowQueryNotification(false);
	};
	return (
		<div className="queryNotification">
			Wyłączenie powiadomień w toku potwierdź
			<div className="queryNotificationButtons">
				<button className="queryNotificationButton" onClick={handleRemove}>
					WYŁĄCZ
				</button>
				<button className="queryNotificationButton" onClick={handleAnuluj}>
					ANULUJ
				</button>
			</div>
		</div>
	);
};
